/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AccountDailyRiskQueryForm model module.
   * @module account_mgt/model/AccountDailyRiskQueryForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountDailyRiskQueryForm</code>.
   * @alias module:account_mgt/model/AccountDailyRiskQueryForm
   * @class
   * @param pageNum {Integer} 页码
   * @param riskDate {Date} 风控日期 yyyy-MM-dd，按东八区自然日理解，转换为UTC时间作为SQL查询条件
   */
  var exports = function(pageNum, riskDate) {
    var _this = this;

    _this['pageNum'] = pageNum;







    _this['riskDate'] = riskDate;
  };

  /**
   * Constructs a <code>AccountDailyRiskQueryForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/AccountDailyRiskQueryForm} obj Optional instance to populate.
   * @return {module:account_mgt/model/AccountDailyRiskQueryForm} The populated <code>AccountDailyRiskQueryForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'pageNum')) {
        obj['pageNum'] = ApiClient.convertToType(data['pageNum'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyId')) {
        obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'frozen')) {
        obj['frozen'] = ApiClient.convertToType(data['frozen'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'riskDate')) {
        obj['riskDate'] = ApiClient.convertToType(data['riskDate'], 'Date');
      }
    }
    return obj;
  }

  /**
   * 页码
   * @member {Integer} pageNum
   */
  exports.prototype['pageNum'] = undefined;
  /**
   * 账号类型 0学生1老师
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * companyId
   * @member {Integer} companyId
   */
  exports.prototype['companyId'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;
  /**
   * 身份证号
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 工号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 当前是否冻结 true:冻结 false:未冻结
   * @member {Boolean} frozen
   */
  exports.prototype['frozen'] = undefined;
  /**
   * 风控日期 yyyy-MM-dd，按东八区自然日理解，转换为UTC时间作为SQL查询条件
   * @member {Date} riskDate
   */
  exports.prototype['riskDate'] = undefined;



  export default exports;
;


